// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + "reimbursement" + "." + "a1ec426b" + ".chunk.css";
};